import axios from "axios"
import {
    getToken
} from "../../storage"
import {
    stringify
} from 'qs';

function createAxios() {
    return axios.create({
        baseURL: '/tyjrmh/api/',
        timeout: 5000,
        headers: {
            "Blade-Auth": getToken(),
            Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        }
    })

}

//获取学员列表数据
export async function getTraineesData(params) {
    return createAxios().get(`/blade-job-startup/sybclassinfo/add/student/page?${stringify(params)}`)
}
//选择课程后  调取该接口获取其他下拉选择数据
export async function getOtherSelectInfo(id) {
    return createAxios().get("/blade-job-startup/sybclassinfo/course/name/show?id=" + id)
}
//获取课程数据
export async function getSubject() {
    return createAxios().get("/blade-job-startup/sybclassinfo/course/name/list")
}

//删除学员
export async function deleteStudent(params) {
    return createAxios().post(`/blade-job-startup/sybclassinfo/remove/student?${stringify(params)}`)
}

//新增班级
export async function addClass(params) {
    return createAxios().post("/blade-job-startup/sybclassinfo/submit", params)
}

// 班级列表查询  
export async function queryClassList(params) {
    return createAxios().get(`/blade-job-startup/sybclassinfo/page?${stringify(params)}`)
}

// 班级详情  
export async function queryClassDetail(id) {
    return createAxios().get("/blade-job-startup/sybclassinfo/detail?id=" + id)
}

// 查看班级详情   table分页 
export async function queryClassDetailList(params) {
    return createAxios().get(`/blade-job-startup/sybclassinfo/see/students/page?${stringify(params)}`)
}

//  查看班级详情页面 学员打分
export async function studentScore(params) {
    return createAxios().get(`/blade-job-startup/sybclassinfo/students/score?${stringify(params)}`)
}


//  编辑班级页面 学员列表分页  暂不调用
export async function editClassStudentList(params) {
    return createAxios().get(`/blade-job-startup/sybclassinfo/update/student/page?${stringify(params)}`)
}